import { Listings } from '../../../../api/api-listings';
import { get } from 'lodash';
import * as types from '../constants/action-types';


const fetchListingRequest = (listingToFetch) => {
  return {
    type: types.LISTING_FETCH_REQUEST,
    listingToFetch
  };
};

const fetchListingSuccess = (data) => {
  return {
    type: types.LISTING_FETCH_SUCCESS,
    data
  };
};

const fetchListingFailure = (fetchError) => {
  return {
    type: types.LISTING_FETCH_FAILURE,
    fetchError
  };
};

const clearListingData = () => {
  return {
    type: types.LISTING_CLEAR_STORE
  };
};

const updateListingRequest = () => {
  return {
    type: types.LISTING_UPDATE_REQUEST,
    isPatching: true
  };
};

const updateListingSuccess = () => {
  return {
    type: types.LISTING_UPDATE_SUCCESS,
    isPatching: false
  };
};

const updateListingFailure = (updateError) => {
  return {
    type: types.LISTING_UPDATE_FAILURE,
    isPatching: false,
    updateError
  };
};

export const fetchListingInfo = (listingID, callback) => {
  return dispatch => {
    dispatch(fetchListingRequest(listingID));
    Listings.read(listingID, (response) => {
      let dispatchFN;
      if (200 === response.statusCode) {
        dispatchFN = fetchListingSuccess;
      } else {
        dispatchFN = fetchListingFailure;
      }

      if (callback) {
        callback(response);
      }

      return dispatch(dispatchFN(response));
    });
  };
};

export const addListingInfo = (listing) => {
  return dispatch => {
    dispatch(fetchListingSuccess(listing));
  };
};

export const updateListing = (listingId, token, payload) => {
  // update: function updateListing (query, token, payload, callback) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(updateListingRequest());

      return Listings.update(`${listingId}`, token, payload, (response) => {
        if (200 === response.statusCode) {
          const listing = get(response, 'space', {});

          dispatch(updateListingSuccess());
          return resolve(listing);
        }

        const fetchError = response;

        dispatch(updateListingFailure(fetchError));
        return reject(fetchError);
      });
    });
  };
};

export const clearListingStore = () => {
  return dispatch => {
    dispatch(clearListingData());
  };
};
